<!-- 修改资料 -->
<template>
  <div class="edit-form">
    <el-dialog :visible.sync="previewShow">
      <img width="100%" :src="previewImageUrl" alt="" />
    </el-dialog>
    <el-alert
      style="margin-bottom: 20px"
      type="error"
      show-icon
      :closable="false"
      title="审核未通过，请重新提交个人信息"
      :description="'原因：' + userInfo.noPassReason"
      v-if="userInfo.noPassReason"
    ></el-alert>
    <el-form
      ref="form"
      :model="userInfo"
      :rules="editRules"
      label-width="100px"
      label-position="left"
    >
      <el-form-item label="身份证号">
        <el-input v-model="userInfo.idNum" disabled></el-input>
      </el-form-item>
      <el-form-item label="身份证照片" prop="idNumUrl">
        <div class="card-boxs">
          <div class="card-box">
            <div class="top">
              <div
                class="empty"
                v-show="!userInfo.idNumUrl"
                @click="startUpload"
              >
                <img class="idCard" src="@/assets/idCard.png" alt="" />
              </div>
              <div class="file" v-show="userInfo.idNumUrl">
                <img :src="URL + userInfo.idNumUrl" />
                <div class="hover-box">
                  <i
                    class="el-icon-zoom-in"
                    @click="preview({ url: URL + userInfo.idNumUrl })"
                  ></i>
                  <i class="el-icon-delete" @click="idCardRemove"></i>
                </div>
              </div>
            </div>
            <input
              ref="card-ipt"
              type="file"
              accept="image/*"
              @change="cardSelect"
            />
            <div class="label">上传身份证正面</div>
          </div>
          <div class="card-box">
            <div class="top">
              <div
                class="empty"
                v-show="!userInfo.idNumReverseUrl"
                @click="startUploadReverse"
              >
                <img class="idCard" src="@/assets/idCard_reverse.png" alt="" />
              </div>
              <div class="file" v-show="userInfo.idNumReverseUrl">
                <img :src="URL + userInfo.idNumReverseUrl" />
                <div class="hover-box">
                  <i
                    class="el-icon-zoom-in"
                    @click="preview({ url: URL + userInfo.idNumReverseUrl })"
                  ></i>
                  <i class="el-icon-delete" @click="idCardReverseRemove"></i>
                </div>
              </div>
            </div>
            <input
              ref="card-ipt-reverse"
              type="file"
              accept="image/*"
              @change="cardReverseSelect"
            />
            <div class="label">上传身份证反面</div>
          </div>
        </div>
        <div class="card-tip">请上传身份证照片或复印件</div>
      </el-form-item>
      <el-form-item label="真实姓名" prop="trainUserName">
        <el-input
          v-model="userInfo.trainUserName"
          placeholder="请输入真实姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="userInfo.gender">
          <el-radio label="男">男</el-radio>
          <el-radio label="女">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="电话号码" prop="phoneNo">
        <el-input
          v-model="userInfo.phoneNo"
          type="number"
          placeholder="请输入电话号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="职称">
        <el-input
          v-model="userInfo.position"
          placeholder="请输入职称"
        ></el-input>
      </el-form-item>
      <el-form-item label="学历">
        <el-select v-model="userInfo.education">
          <el-option label="小学" value="小学"></el-option>
          <el-option label="初中" value="初中"></el-option>
          <el-option label="高中" value="高中"></el-option>
          <el-option label="大专" value="大专"></el-option>
          <el-option label="本科" value="本科"></el-option>
          <el-option label="研究生" value="研究生"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="寸照">
        <el-upload
          :action="uploadURL"
          :file-list="fileList"
          :headers="{ token }"
          list-type="picture-card"
          :on-preview="preview"
          :on-success="uploadSuccess"
          :on-remove="uploadRemove"
          accept="image/*"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            需提供蓝底证件照，否则不能生成电子证书
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="毕业证">
        <el-upload
          :action="uploadURL"
          :file-list="certList"
          :headers="{ token }"
          list-type="picture-card"
          :on-preview="preview"
          :on-success="certUploadSuccess"
          :on-remove="certUploadRemove"
          accept="image/*"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <template #label>
          <el-tooltip effect="dark" content="纸质证件收货地址" placement="top">
            <div>
              <span>收货地址</span>
              <i class="el-icon-question"></i>
            </div>
          </el-tooltip>
        </template>
        <el-input
          v-model="userInfo.paperAddress"
          placeholder="请输入详细的收货地址"
        ></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="saveData">提 交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { uploadURL, URL } from "../../util/config";
export default {
  data() {
    const phoneValid = (r, v, cb) => {
      const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
      if (v == "" || reg.test(v)) {
        cb();
        return;
      }
      cb("请输入正确的手机号");
    };
    return {
      URL,
      uploadURL,
      token: "",
      userInfo: {
        idNum: "",
        trainUserName: "",
        gender: "",
        position: "",
        phoneNo: "",
        imgUrl: "",
        education: "",
        paperAddress: "",
        workTypeName: "",
        idNumUrl: "", // 身份证正面
        idNumReverseUrl: "", // 身份证反面
        graduationCertUrl: "", // 毕业证
      },
      editRules: {
        idNumUrl: {
          required: true,
          message: "请上传身份证照片",
          trigger: "blur",
        },
        trainUserName: {
          required: true,
          message: "请输入真实姓名",
          trigger: "blur",
        },
        phoneNo: { validator: phoneValid, trigger: "blur" },
      },
      fileList: [],
      certList: [],
      previewShow: false,
      previewImageUrl: "",
    };
  },
  created() {
    this.token = localStorage.getItem("token");
    if (this.token) {
      this.getDetail();
    }
  },
  methods: {
    // 获取个人信息
    getDetail() {
      this.$api.getUserInfo().then((res) => {
        if (res.code == 0) {
          this.userInfo = res.data;
          if (this.userInfo.imgUrl) {
            this.fileList = [{ url: URL + this.userInfo.imgUrl }];
          }
          if (this.userInfo.graduationCertUrl) {
            this.certList = [{ url: URL + this.userInfo.graduationCertUrl }];
          }
        }
      });
    },
    // 正面照上传事件
    startUpload() {
      this.$refs["card-ipt"].click();
    },
    async cardSelect(e) {
      const files = e.target.files;
      let formData = new FormData();
      formData.append("file", files[0]);
      let res = await this.uploadFile(formData);
      if (res.code != 0) {
        this.$notify.error({ title: res.msg });
        return;
      }
      this.userInfo.idNumUrl = res.data;
    },
    idCardRemove() {
      this.userInfo.idNumUrl = "";
    },
    // 反面照上传事件
    startUploadReverse() {
      this.$refs["card-ipt-reverse"].click();
    },
    async cardReverseSelect(e) {
      const files = e.target.files;
      let formData = new FormData();
      formData.append("file", files[0]);
      let res = await this.uploadFile(formData);
      if (res.code != 0) {
        this.$notify.error({ title: res.msg });
        return;
      }
      this.userInfo.idNumReverseUrl = res.data;
    },
    idCardReverseRemove() {
      this.userInfo.idNumReverseUrl = "";
    },
    uploadFile(formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(uploadURL, formData, { Headers: { token: this.token } })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 寸照上传
    uploadSuccess(res) {
      if (res.code == 0) {
        this.userInfo.imgUrl = res.data;
      } else {
        this.fileList = [];
        this.$notify.error({ title: res.msg });
      }
    },
    uploadRemove() {
      this.userInfo.imgUrl = "";
      this.fileList = [];
    },
    // 毕业证上传
    certUploadSuccess(res) {
      if (res.code == 0) {
        this.userInfo.graduationCertUrl = res.data;
      } else {
        this.certList = [];
        this.$notify.error({ title: res.msg });
      }
    },
    certUploadRemove() {
      this.userInfo.graduationCertUrl = "";
      this.certList = [];
    },
    preview(file) {
      this.previewImageUrl = file.url;
      this.previewShow = true;
    },
    // 保存信息
    saveData() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await this.$api.completeUserInfo(this.userInfo);
          if (res.code == 0) {
            this.$notify.success({
              title: "提交成功!",
              message: "待审核后方可生效!",
            });
            this.getDetail();
            setTimeout(() => {
              this.$router.push("/mine/profile");
            }, 500);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-boxs {
  display: flex;
}
.card-box {
  margin-right: 15px;
  border-radius: 5px;
  overflow: hidden;

  .top {
    background-color: #fef0f0;

    .empty {
      padding: 20px;
      cursor: pointer;
    }

    .idCard {
      width: auto;
      height: 135px;
      display: block;
    }

    .file {
      height: 175px;
      position: relative;

      &:hover {
        .hover-box {
          opacity: 1;
        }
      }

      img {
        width: auto;
        height: 100%;
      }

      .hover-box {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: 0.5s;

        i {
          cursor: pointer;
          font-size: 22px;
        }
        i + i {
          margin-left: 20px;
        }
      }
    }
  }
  input {
    display: none;
  }
  .label {
    text-align: center;
    background-color: $theme;
    color: #fff;
    font-size: 14px;
    line-height: 35px;
  }
}
.card-tip {
  font-size: 12px;
  color: #606266;
  margin-top: 7px;
}
</style>
